import { render, staticRenderFns } from "./CreateReservation.vue?vue&type=template&id=2db5ff0e&lang=pug"
import script from "./CreateReservation.vue?vue&type=script&lang=js"
export * from "./CreateReservation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports